import { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { io } from 'socket.io-client';

const SocketContext = createContext(null);

const SOCKET_SERVER_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:5000'
    : process.env.REACT_APP_PROD_SOCKET_URL;

export const SocketProvider = ({ children }) => {
  const { quizUserInfo, quizGroups } = useSelector((state) => state.quizAuth);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (!quizUserInfo) return;

    const newSocket = io(SOCKET_SERVER_URL, {
      path: '/socket.io',
      withCredentials: true,
      auth: {
        token: quizUserInfo.token,
        userId: quizUserInfo.id,
        username: quizUserInfo.username,
      },
    });

    setSocket(newSocket);

    newSocket.on('connect', () => {
      console.log('Global socket connected:', newSocket.id);
    });

    newSocket.on('disconnect', () => {
      console.warn('Global socket disconnected');
    });

    return () => {
      newSocket.disconnect();
    };
  }, [quizUserInfo]);

  useEffect(() => {
    if (!socket || !socket.connected) return;
    if (!quizUserInfo || !quizGroups?.length) return;

    quizGroups.forEach(group => {
      socket.emit(
        'join_group_room',
        {
          groupId: group.id,
          groupKey: group.group_key,
        },
        res => {
          if (!res.success) {
            console.error('Failed to join room:', res.message);
          }
        }
      );
    });
  }, [socket, socket?.connected, quizUserInfo, quizGroups]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
